<template>
  <div>
    <img
      v-if="lastMessageIn.rssi >= -99.9"
      width="24"
      src="@/assets/icons/signal/ico/sila-rssi-01.svg"
    />
    <img
      v-else-if="lastMessageIn.rssi < -99.9 && lastMessageIn.rssi >= 109.9"
      width="24"
      src="@/assets/icons/signal/ico/sila-rssi-02.svg"
    />
    <img
      v-else-if="lastMessageIn.rssi < -109.9 && lastMessageIn.rssi >= -114.9"
      width="24"
      src="@/assets/icons/signal/ico/sila-rssi-03.svg"
    />
    <img
      v-else-if="lastMessageIn.rssi < -114.9 && lastMessageIn.rssi >= -119.9"
      width="24"
      src="@/assets/icons/signal/ico/sila-rssi-04.svg"
    />
    <img
      v-else-if="lastMessageIn.rssi < -119.9"
      width="24"
      src="@/assets/icons/signal/ico/sila-rssi-05.svg"
    />
    <div v-else class="d-flex align-items-center">
      <img
        src="@/assets/icons/signal/ico/sila-rssi-na.svg"
        width="24"
        class="mr-2"
      />
      N/A
    </div>
  </div>
</template>

<script>
export default {
  props: {
    lastMessageIn: Object
  },
  data() {
    return {};
  },
  mounted() {}
};
</script>

<style lang="scss" scoped></style>
